export default __webpack_public_path__ + "static/media/Travis-Scott-Jordan-1-Low.78d14b1e.png";